import { useNode } from '@craftjs/core';
import { cn } from '../../../../lib/utils';

interface CTABlockProps {
  text: string;
  url: string;
  bgColor: string;
  textColor: string;
  size: 'sm' | 'md' | 'lg';
  fullWidth: boolean;
  ctaId: string;
}

const sizeClasses: Record<string, string> = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-3 text-base',
  lg: 'px-8 py-4 text-lg',
};

export function CTABlock({ text, url, bgColor, textColor, size, fullWidth, ctaId }: CTABlockProps) {
  const {
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    selected: state.events.selected,
  }));

  return (
    <div
      ref={(ref) => {
        if (ref) connect(drag(ref));
      }}
      className={cn(
        'p-2 rounded transition-all flex',
        fullWidth ? 'justify-stretch' : 'justify-start',
        selected && 'ring-2 ring-primary ring-offset-2'
      )}
    >
      <a
        href={url || '#'}
        id={ctaId || undefined}
        onClick={(e) => e.preventDefault()}
        className={cn(
          'inline-block font-semibold rounded transition-opacity hover:opacity-90 cursor-not-allowed',
          sizeClasses[size],
          fullWidth && 'w-full text-center'
        )}
        style={{ backgroundColor: bgColor, color: textColor }}
      >
        {text}
      </a>
    </div>
  );
}

CTABlock.craft = {
  displayName: 'Botão CTA',
  props: {
    text: 'Saiba mais',
    url: '#',
    bgColor: '#50E3C2',
    textColor: '#0d0d0d',
    size: 'md' as const,
    fullWidth: false,
    ctaId: '',
  },
  rules: { canDrag: () => true },
};
